const pillars = [
  {
    icon: 'ri-compass-3-line',
    t: '我们是谁',
    d: '八卦吃瓜是一份专注「红毯与活动现场造型」的中文娱乐时尚点评小报，用轻松但认真的态度，陪你把每一次出场的瓜啃明白。',
  },
  {
    icon: 'ri-book-open-line',
    t: '我们的定位',
    d: '不追着明星私生活跑，只聚焦「穿得好不好看」这件事。从版型、配色、妆容到动作管理，讲清造型背后的门道，也保留纯粹的吃瓜快乐。',
  },
  {
    icon: 'ri-hand-heart-line',
    t: '内容原则',
    d: '基于画面与可见事实点评，观点不冒充事实；鼓励多元审美，欢迎不同意见。让讨论更有趣，也让每一次翻车都变成一堂穿搭课。',
  },
];

export default function About() {
  return (
    <section id="about" className="relative w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-5 lg:items-center">
          {/* 介绍文本 */}
          <div className="lg:col-span-2">
            <p className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.24em] text-primary-500">
              <i className="ri-group-line text-base"></i>
              ABOUT US
            </p>
            <h2 className="rule-line font-display text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
              八卦吃瓜
              <br />
              一份敢说的红毯吃瓜报
            </h2>
            <p className="mt-6 text-sm leading-relaxed text-foreground-700">
              我们相信，造型是公众人物给观众的一场「第一印象演出」，也相信每个人都有发表审美的权利。
              八卦吃瓜想做的，就是把这场演出最有趣、最值得聊的片段剪出来，配上一点点专业知识、
              一点点毒舌和很多很多真诚，送到你面前。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              红毯翻车也好，撞衫对比也罢，在小编眼里都不是嘲笑的素材，而是了解「如何穿得更好看」的窗口。
              瓜要吃，审美的功课也要交。
            </p>
            <div className="mt-7 flex items-center gap-4">
              <a
                href="#contact"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-mail-send-line text-base"></i>
                联系编辑部
              </a>
              <a
                href="#pan"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                去逛盘点
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>
          </div>

          {/* 三支柱卡片 */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:col-span-3 lg:grid-cols-1 xl:grid-cols-1">
            {pillars.map((p) => (
              <div
                key={p.t}
                className="group flex items-start gap-5 rounded-xl border border-background-200/80 bg-foreground-50 p-6 transition-colors hover:border-primary-200 hover:bg-primary-50"
              >
                <span className="flex h-13 w-13 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-2xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={p.icon}></i>
                </span>
                <div>
                  <h3 className="font-display text-xl font-bold text-foreground-950">{p.t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 联系区块 */}
        <div
          id="contact"
          className="mt-16 grid scroll-mt-24 grid-cols-1 gap-8 overflow-hidden rounded-2xl bg-primary-900 p-8 md:p-10 lg:grid-cols-2"
        >
          <div>
            <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.24em] text-accent-300">
              <i className="ri-message-3-line text-base"></i>
              CONTACT
            </p>
            <h3 className="mt-3 font-display text-2xl font-black leading-snug text-background-50 md:text-3xl">
              有瓜想投稿，或有意见想拍砖？
              <br />
              欢迎来信，桃桃逐条看。
            </h3>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/85">
              无论是活动现场造型投稿、事实细节纠正，还是单纯想聊聊你对某套穿搭的看法，
              都可以写给我们。投稿请尽量附上活动名称与大致时间，方便小编核对排期。
            </p>
          </div>
          <div className="flex flex-col justify-center gap-4 rounded-xl bg-foreground-950/20 p-6 md:p-8">
            <address className="not-italic">
              <p className="text-xs font-medium uppercase tracking-[0.2em] text-background-100/60">
                编辑部邮箱
              </p>
              <a
                href="mailto:hello@chigua-redcarpet.example"
                className="mt-2 inline-flex items-center gap-2 font-display text-xl font-bold text-background-50 transition-colors hover:text-accent-300 md:text-2xl"
              >
                <i className="ri-mail-line text-accent-300"></i>
                hello@chigua-redcarpet.example
              </a>
              <p className="mt-4 text-xs leading-relaxed text-background-100/70">
                栏目与商务咨询请统一发送至上述邮箱，
                <br />
                主题注明「投稿 / 纠错 / 合作」即可，48 小时内回复。
              </p>
            </address>
          </div>
        </div>
      </div>
    </section>
  );
}